import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import ProblemSection from "@/components/landing/ProblemSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import BuiltForSection from "@/components/landing/BuiltForSection";
import FAQSection from "@/components/landing/FAQSection";
import BookingSection from "@/components/landing/BookingSection";
import Footer from "@/components/landing/Footer";

const Landing = () => {
  return (
    <div className="bg-background">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <HowItWorksSection />
      <BuiltForSection />
      <FAQSection />
      <BookingSection />
      <Footer />
    </div>
  );
};

export default Landing;
